import { safeGetItem, safeSetItem } from '../utils/safeLocalStorage';

const ENGAGEMENT_KEY = 'bigwa-pwa-engagement-count';
const LAST_SESSION_KEY = 'bigwa-pwa-last-session';
const THRESHOLD = 3;

/**
 * Registra uma ação de engajamento para o prompt PWA.
 * Chamar nos pontos estratégicos do app (edição cirúrgica, 1 linha cada).
 * Não rastreia se já está instalado (standalone).
 */
export function trackPWAEngagement(weight: number = 1): void {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches
    || (window.navigator as unknown as Record<string, unknown>).standalone === true;
  if (isStandalone) return;

  const current = Number(safeGetItem(ENGAGEMENT_KEY) || '0');
  if (current >= THRESHOLD) return;

  const newValue = Math.min(current + weight, THRESHOLD + 5);
  safeSetItem(ENGAGEMENT_KEY, String(newValue));

  // Disparar evento quando threshold é atingido mid-session
  if (current < THRESHOLD && newValue >= THRESHOLD) {
    window.dispatchEvent(new CustomEvent('bigwa:engagement-threshold-reached'));
  }
}

/**
 * Registra nova sessão. Chamar no mount do App.
 * Se >1h desde última sessão, conta como sessão distinta (peso 2).
 */
export function trackPWASession(): void {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches
    || (window.navigator as unknown as Record<string, unknown>).standalone === true;
  if (isStandalone) return;

  const lastSession = Number(safeGetItem(LAST_SESSION_KEY) || '0');
  const now = Date.now();
  const hoursSince = (now - lastSession) / (1000 * 60 * 60);

  if (hoursSince > 1) {
    trackPWAEngagement(2);
  }

  safeSetItem(LAST_SESSION_KEY, String(now));
}

/**
 * Verifica se o threshold foi atingido.
 * Chamado pelo PWAInstallPrompt para decidir se mostra.
 */
export function hasPWAEngagementThreshold(): boolean {
  return Number(safeGetItem(ENGAGEMENT_KEY) || '0') >= THRESHOLD;
}
